import { VersionsData } from '@/src/services/getVersionsData';
import PreviousVersionsComponent from './PreviousVersionsComponent';

const PersonalLicenses = ({ versionsData }: { versionsData: VersionsData }) => {
  return <PreviousVersionsComponent versionsData={versionsData} />;
};

export default PersonalLicenses;
